export type BooksyPayEntryTarget = 'activation' | 'onboarding'

export const BOOKSY_PAY_ENTRY_TARGETS = {
  ACTIVATION: 'activation',
  ONBOARDING: 'onboarding',
} as const satisfies Record<string, BooksyPayEntryTarget>
